module.exports = __webpack_public_path__ + "static/media/business-interdisciplinary@2x.e3c434d6.png";